import React, { useState } from "react";

export default function Purshkar() {
  // images expected: public/images/a.jpeg ... e.jpeg
  const images = ["a", "b", "c", "d", "e"].map(
    (ch) => `${process.env.PUBLIC_URL}/images/${ch}.jpeg`
  );

  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      {/* INTERNAL CSS */}
      <style>{`
        .page {
          min-height: 100vh;
          padding: 24px;
          background: linear-gradient(to bottom, #ffffff, #f3f3f3);
        }

        .wrapper {
          max-width: 1200px;
          margin: auto;
        }

        .title {
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 20px;
        }

        .subtitle {
          color: #666;
          margin-bottom: 20px;
        }

        .grid-box {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          gap: 16px;
        }

        @media (min-width: 600px) {
          .grid-box {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 900px) {
          .grid-box {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        .img-btn {
          overflow: hidden;
          border-radius: 18px;
          border: none;
          padding: 0;
          cursor: pointer;
          transition: all 0.2s ease;
          background: none;
        }

        .img-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .thumb-img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        /* Modal */
        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 50;
          padding: 16px;
        }

        .modal-content {
          position: relative;
          width: 100%;
          max-width: 900px;
        }

        .close-btn {
          position: absolute;
          top: 12px;
          right: 12px;
          background: rgba(0,0,0,0.4);
          color: white;
          border-radius: 50%;
          padding: 8px 14px;
          border: none;
          cursor: pointer;
        }

        .big-img {
          width: 100%;
          max-height: 70vh;
          object-fit: contain;
          background: white;
          border-radius: 12px;
          padding: 8px;
        }

        .modal-footer {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          color: white;
          font-size: 18px;
          align-items: center;
        }

        .nav-btn {
          background: rgba(0,0,0,0.4);
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
        }
      `}</style>

      {/* MAIN PAGE */}
      <div className="page">
        <div className="wrapper">
          <h1 className="title">पुरस्कार आणि छायाचित्रे</h1>

         

          <div className="grid-box">
            {images.map((src, idx) => (
              <button
                key={idx}
                onClick={() => setOpenIndex(idx)}
                className="img-btn"
              >
                <img src={src} alt="" className="thumb-img" />
              </button>
            ))}
          </div>

          {/* MODAL */}
          {openIndex !== null && (
            <div className="modal-backdrop">
              <div className="modal-content">
                <button
                  onClick={() => setOpenIndex(null)}
                  className="close-btn"
                >
                  बंद
                </button>

                <img
                  src={images[openIndex]}
                  className="big-img"
                  alt=""
                />

                <div className="modal-footer">
                  <button
                    className="nav-btn"
                    onClick={() =>
                      setOpenIndex((i) => (i === 0 ? images.length - 1 : i - 1))
                    }
                  >
                    मागे
                  </button>

                  <span>{openIndex + 1} / {images.length}</span>

                  <button
                    className="nav-btn"
                    onClick={() =>
                      setOpenIndex((i) =>
                        i === images.length - 1 ? 0 : i + 1
                      )
                    }
                  >
                    पुढे
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
